import React, { useState, useEffect } from 'react';
import { FaArrowCircleLeft, FaArrowCircleRight, FaFemale, FaMale } from 'react-icons/fa';
import ravip from '../../images/RAVIP-scaled.jpg';
import diaspora from '../../images/diaspora.png';
import tradux from '../../images/TRADUX-scaled.jpg';

const slides = [
  {
    image: tradux,
    link: 'https://tradux.gouv.bj/',
  },
  {
    image: ravip,
    link: 'https://lei.anip.bj/',
  },
  {
    image: diaspora,
    link: 'https://rdv-paris.diplomatie.bj/',
  },
];

const staticInfo = {
  totalCountries: 42,
  menPercentage: 42,
  womenPercentage: 43,
};

function ServiceCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="ServiceCarousel-section-container">
      <div className="static-info-panel">
        <div className="info-box">
          <div className="info-circle">
            <span className="info-number">{staticInfo.totalCountries}</span>
          </div>
          <span className="info-label">Pays Hôtes</span>
        </div>
        <div className="gender-info">
          <div className="gender-item">
            <div className="gender-icon">
                <FaMale size={25}/>
            </div>
            <div className="gender-text">
              <span className="gender-percentage">{staticInfo.menPercentage}%</span>
              <span className="gender-label">Hommes</span>
            </div>
          </div>
          <div className="gender-item">
            <div className="gender-icon">
                <FaFemale size={25}/>
            </div>
            <div className="gender-text">
              <span className="gender-percentage">{staticInfo.womenPercentage}%</span>
              <span className="gender-label">Femmes</span>
            </div>
          </div>
        </div>
      </div>

      <div className="ServiceCarousel-container">
        <div className="ServiceCarousel-inner" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
          {slides.map((slide, index) => (
            <div className="ServiceCarousel-slide" key={index}>
              <a href={slide.link} target="_blank" rel="noopener noreferrer">
                <img src={slide.image} alt={`Slide ${index + 1}`} />
                <button className="learn-more-button">En savoir plus</button>
              </a>
            </div>
          ))}
        </div>
        <div className="ServiceCarousel-pagination">
        <button onClick={prevSlide} className="ServiceCarousel-button prev">
          <FaArrowCircleLeft />
        </button>
          {slides.map((_, index) => (
            <span
              key={index}
              className={`pagination-dot ${currentSlide === index ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
            ></span>
          ))}
        <button onClick={nextSlide} className="ServiceCarousel-button next">
          <FaArrowCircleRight />
        </button>
        </div>
      </div>
    </section>
  );
}

export default ServiceCarousel;